import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { EndocrineAndrogensDiagramContent } from "./EndocrineAndrogensDiagram";
import { EndocrineAndrogensKeyContent } from "./EndocrineAndrogensKey";

const SvgEndocrineAndrogensDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1540}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 895, 1173)}
      viewBox={diagramOnly ? "0 204 1540 895" : "0 0 1540 1173"}
    >
      <g id="endocrine-androgens-diagram+key" clipPath="url(#clip0_18293_224294)">
        <rect width={1540} height={diagramOnly ? 895 : 1173} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <EndocrineAndrogensKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <EndocrineAndrogensDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18293_224294">
          <rect width={1540} height={1173} fill="white" />
        </clipPath>
        <clipPath id="clip1_18293_224294">
          <rect width={1540} height={895} fill="white" transform="translate(0 204)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgEndocrineAndrogensDiagramKey;
